import { useQuery } from "react-query";
import { getHvacByRecordNumber } from "../../../../actions/CarrierAgreementMgmt/Security";

export const useGetHvacsByRecordNumber = (recNumber) => {
  return useQuery(
    ["GetHvacsByRecordNumber", recNumber],
    () => getHvacByRecordNumber(recNumber),
    { refetchOnWindowFocus: false }
  );
};
